/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlRelationshipFieldsFragment = {
  __typename: "Relationship";
  id: string;
  name: string;
  contactId?: string | null;
  representativeIds?: Array<string> | null;
};

export const RelationshipFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relationshipFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relationship" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "representativeIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlRelationshipFieldsFragment, unknown>;
